






























































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { MessageDto } from "@/store/messages/message.interface";
import dayjs from "dayjs";
import ConfirmModal from "@/components/modal/Confirm.vue";

@Component
export default class AppMessageForm extends Vue {
  @Prop() data: MessageDto;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;

  form: any = {};

  @Emit("onSubmit")
  async onSubmit() {
    return {
      ...this.form,
      status_id: this.form.is_active ? this.form.status_id : 5,
      send_date:
        dayjs(this.form.send_date).format("YYYY-MM-DD") +
        " " +
        dayjs(this.form.start_time).format("HH:mm:ss"),
      start_time: dayjs(this.form.start_time).format("HH:mm:ss"),
      end_time: dayjs(this.form.end_time).format("HH:mm:ss"),
      is_active: this.form.is_active ? true : false,
      tags: (this.form.tags || []).map((item: any) => {
        if (typeof item === "object") {
          return item.name;
        }
        return item;
      })
    };
  }

  @Emit("onCancel")
  async onCancel() {}

  @Emit("onEditable")
  async onEditable() {}

  reset() {
    this.form = {
      name: ""
    };
  }

  @Watch("data", { immediate: true, deep: true })
  onDataChange(data: MessageDto, oldData: MessageDto) {
    const today = dayjs().format("YYYY-MM-DD");
    this.form = data
      ? {
          ...data,
          send_date: data.send_date ? dayjs(data.send_date).toDate() : null,
          start_time: data.start_time
            ? dayjs(today + " " + data.start_time).toDate()
            : null,
          end_time: data.end_time
            ? dayjs(today + " " + data.end_time).toDate()
            : null
        }
      : {};
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  @Emit("onRemove")
  async onConfirmRemove() {
    return true;
  }
}
